import { useAppContext } from '../Services/AppContext';

export const createPriceObject = (
	price: number,
	currency: string,
	vatRate: number,
) => {
	const priceWithoutVat = price / getVatRateDivisible(vatRate);
	return {
		price: priceWithoutVat,
		priceVat: price - priceWithoutVat,
		priceWithVat: price,
		currency: currency,
		vatRate: vatRate,
	};
};

const getVatRateDivisible = (vatRate: number) => {
	return vatRate / 100 + 1;
};
